/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import EmailPasswordForm from '../EmailPasswordForm';
import FormLinks from '../FormLinks';
import { ErrorBoundary } from '../UI';
import '../../index.css';
import SocialLogin from '../SocialLogin';
import Consents from '../Consents';
/**
 * Renders the sign-up component
 *
 * @param  {string} [className] - the CSS classes
 * @param  {(email: string, password: string) => void} [onClick] - onClick handler launching after submit form
 * @param  {(response: any) => void} [onSocialClick] - onClick handler launching after submit on social providers
 * @param  {string} [apiError] - api error messages
 * @param  {(to: string) => void} [onLinkHandler] - links onClick handler
 * @param  {string} [inputStyles] - input CSS classes
 * @param  {string} [buttonStyles] - btn CSS classes
 * @param  {string} [labelStyles] - label CSS classes
 * @param  {string} [linkStyles] - link CSS classes
 * @param  {string} [formStyles] - form CSS classes
 * @param  {string} [formGroupStyles] - form group CSS classes
 *
 * @example
 * <SignUp
 *  className='a6y-react-auth__sign-up'
 *  onClick={onClick}
 *  onLinkHandler={onLinkHandler}
 * />
 */
var SignUp = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.className, className = _f === void 0 ? 'a6y-react-auth__sign-up' : _f, onClick = _a.onClick, onSocialClick = _a.onSocialClick, apiError = _a.apiError, _g = _a.onLinkHandler, onLinkHandler = _g === void 0 ? undefined : _g, _h = _a.inputStyles, inputStyles = _h === void 0 ? '' : _h, _j = _a.buttonStyles, buttonStyles = _j === void 0 ? '' : _j, _k = _a.labelStyles, labelStyles = _k === void 0 ? '' : _k, _l = _a.linkStyles, linkStyles = _l === void 0 ? '' : _l, _m = _a.formStyles, formStyles = _m === void 0 ? '' : _m, _o = _a.formGroupStyles, formGroupStyles = _o === void 0 ? '' : _o;
    var _p = useState(false), conditions = _p[0], setConditions = _p[1];
    var _q = useState(false), conditionsError = _q[0], setConditionsError = _q[1];
    var onSubmit = function (email, password) {
        setConditionsError(!conditions);
        if (onClick && conditions) {
            onClick(email, password);
        }
    };
    return (React.createElement("div", { className: className },
        React.createElement("h1", null, globalThis.A6YReactAuthConfig &&
            ((_c = (_b = globalThis.A6YReactAuthConfig.components) === null || _b === void 0 ? void 0 : _b.signUp) === null || _c === void 0 ? void 0 : _c.title)
            ? (_e = (_d = globalThis.A6YReactAuthConfig.components) === null || _d === void 0 ? void 0 : _d.signUp) === null || _e === void 0 ? void 0 : _e.title
            : 'Sign Up'),
        React.createElement(ErrorBoundary, { showError: apiError ? true : false }, apiError),
        React.createElement(ErrorBoundary, { showError: conditionsError ? true : false }, "All required consents must be accepted."),
        onSocialClick && React.createElement(SocialLogin, { callback: onSocialClick }),
        React.createElement(EmailPasswordForm, { inputStyles: inputStyles, labelStyles: labelStyles, buttonStyles: buttonStyles, formStyles: formStyles, formGroupStyles: formGroupStyles, signUp: true, submitLabel: 'sign up', onClick: onSubmit }),
        React.createElement(Consents, { isValid: function (value) { return setConditions(value); } }),
        React.createElement(FormLinks, { linkStyles: linkStyles, onLinkHandler: onLinkHandler, path: 'sign-up' })));
};
export default SignUp;
//# sourceMappingURL=SignUp.js.map